<div class="h-full w-full gap-6">
  <app-page-header>
    <div class="flex flex-row justify-start items-center gap-2 h-10">
      <span>Organisationseinstellungen</span>
    </div>
  </app-page-header>

  @if (organisation && stateService.selectedOrganisation) {
<div class="h-full w-full overflow-y-scroll p-6">
    <bic-accordion [gapBetweenElements]="0" [openedIndex]="openedPanel" #accordion>
      <!-- panel: general organisationList info -->
      <bic-accordion-element #panel1>
        <bic-accordion-header>
          <div>1. {{ organisation.name }}</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="generalInfo"></ng-container>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: address -->
      <bic-accordion-element>
        <bic-accordion-header>
          <div>2. Adresse</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="addressInfo"></ng-container>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: organisationList members -->
      <bic-accordion-element>
        <bic-accordion-header>
          <div>3. Organisationsmitglieder</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <div>
            <app-users-list
              [addDisabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)"
              [deleteDisabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)"
              [permissionsDisabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)"
              [isProject]="false"
              [organisation]="organisation"
              [changeEventTriggered]="organisationChangedEvent.asObservable()"
              [fromProjectAccordion]="true"
            ></app-users-list>
          </div>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: externe Datenquellen (BIC-Frontend#2719), nur fuer Org-Admins -->
      @if (permissionService.hasOrganisationPrivilege('ORGANISATION_SETTINGS', organisation.id!)) {
        <bic-accordion-element>
          <bic-accordion-header>
            <div>4. Datenquellen</div>
          </bic-accordion-header>
          <bic-accordion-body>
            <app-organisation-data-sources [organisationId]="organisation.id!"></app-organisation-data-sources>
          </bic-accordion-body>
        </bic-accordion-element>
      }
    </bic-accordion>
  </div>
}
</div>

<ng-template #generalInfo>
  <form [formGroup]="generalInfoForm" class="pt-2 pb-4">
    <div class="flex flex-col justify-start gap-5">
      <div class="flex flex-row justify-center pl-2 gap-16">
        <div class="flex flex-row h-[150px] w-[150px] pt-4 justify-center items-center">
          @if (organisation) {
            <app-organisation-image-upload [(image)]="organisation.profileImage"
                                           [organisation]="organisation"></app-organisation-image-upload>
          }
        </div>

        <div class="flex flex-row h-[150px] w-full justify-between gap-12">
          <div class="flex flex-col justify-between h-full flex-grow gap-5">
            <bic-input class="w-full" [label]="'Name der Organisation *'" [formControlName]="'name'" [maxLength]="64"
                       [errorCondition]="generalInfoForm.controls.name.touched && generalInfoForm.controls.name.invalid"
                       [placeholder]="'Name der Organisation eingeben'" [showX]="false"></bic-input>

            <bic-input class="w-full" [label]="'Geschäftliche E-Mail *'" [formControlName]="'organisationMail'"
                       [placeholder]="'Geschäftliche E-Mail eingeben'" [showX]="false"></bic-input>
          </div>

          <div class="flex flex-col justify-between h-full flex-grow gap-5">
            @if (generalInfoForm.disabled) {
              <bic-input class="w-full" [label]="'Rechtsform'" [value]="$safeNavigationMigration(generalInfoForm.get('legalForm')?.value) | legalForms" [disabled]="true" [showX]="false"></bic-input>
            } @else {
              <bic-select [formControlName]="'legalForm'" [label]="'Rechtsform'" [placeholder]="'Rechtsform auswählen'" [showX]="false" class="w-full">
                @for (i of legalForm | keyvalue; track i) {
                  <bic-dropdown-element [value]="i.value">{{ i.value | legalForms }}</bic-dropdown-element>
                }
              </bic-select>
            }

            <bic-input class="w-full" [label]="'Umsatzsteueridentifikationsnummer'" [formControlName]="'vatNumber'"
                       [errorCondition]="generalInfoForm.controls.vatNumber.touched && generalInfoForm.controls.vatNumber.invalid"
                       [placeholder]="'Umsatzsteueridentifikationsnummer eingeben'"></bic-input>
          </div>
        </div>
      </div>

      <div class="flex flex-row justify-end gap-4">
        @if (permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)) {
          <div>
            <bic-button (onClick)="deleteDialog()" buttonType="white">Löschen</bic-button>
          </div>
        }

        @if (!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)) {
          <div>
            <bic-button (onClick)="leaveDialog()" [tooltip]="'Organisation verlassen'" buttonType="white"
                        text>Verlassen
            </bic-button>
        </div>}

        <div>
          <bic-button (onClick)="save()"
                      [disabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_SETTINGS') || saveDisabled">
            Speichern</bic-button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #addressInfo>
  <div class="flex flex-col justify-start w-full">
    <app-address-input
      formControlNameZipCode="zipCode"
      formControlNameCity="city"
      formControlNameHouseNumber="houseNumber"
      [stateDisabled]="false"
      [countrySelectDisabled]="disableForm()"
      [displayPlotNumber]="false"
      [formGroup]="addressInfoForm"></app-address-input>

    <div class="flex flex-row justify-end pt-5">
      <bic-button  (onClick)="save()"
                  [disabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_SETTINGS') || saveDisabled">Speichern</bic-button>
    </div>
  </div>
</ng-template>
